import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

interface SelectProps {
  options: any;
  defaultValue: number;
  defaultName?: string;
  onChangeValue: any;
  width?: number;
  icon?: string;
  disabled?: boolean;
}

export type SelectType = {
  value: any;
  name: string;
};

const DropdownSelect = ({
  options,
  defaultValue,
  defaultName,
  onChangeValue,
  icon,
  disabled,
}: SelectProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<number>(defaultValue);
  const selectRef = useRef<HTMLDivElement | null>(null);

  const handleSelectClick = () => {
    if (!disabled) setIsOpen(!isOpen);
    // console.log('isOpen', isOpen);
  };

  const handleOptionClick = (option: any) => {
    setTitle(option.name);
    setSelectedOption(option.value);
    onChangeValue(option);
    setIsOpen(false);
  };

  const handleOutsideClick = (event: any) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    setSelectedOption(defaultValue);
    if (defaultName) setTitle(defaultName);
    else
      setTitle(options.find((item: any) => item.value === defaultValue).name);
  }, [defaultValue]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <Style>
      <div className={`selector ${disabled && "disabled"}`} ref={selectRef}>
        <div className="selectHeader" onClick={handleSelectClick}>
          {title}
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down.svg`}
            width={40}
            height={40}
            alt="select"
          />
        </div>
        {isOpen && (
          <ul
            className="selectList"
            style={{
              height: `calc(${
                options.length > 5 ? 30 : options.length * 6
              }vh + 2px)`,
            }}
          >
            {options.map((option: SelectType, index: number) => (
              <li
                key={index}
                onClick={() => handleOptionClick(option)}
                className={`selectItem ${
                  option.value === selectedOption && "selected"
                }`}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </Style>
  );
};
export default DropdownSelect;

export const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .selector {
    display: flex;
    align-items: center;
    width: auto;
    height: 10vh;
    position: relative;
    padding: 0 18px;
    color: #ffffff;
    border: none;
    background: linear-gradient(360deg, #001e62 0%, #6490e8 100%, #5e89e0 100%);
    border-radius: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .selector.disabled {
    background: #e5e5e5;
  }
  .selectHeader {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    font-size: 3.5vh;
    img {
      width: auto;
    }
  }

  .selectList {
    width: calc(100% - 3px);
    position: absolute;
    overflow-y: auto;
    z-index: 1;
    top: 90%;
    left: 2px;
    padding: 0;
    border-radius: 0px 0px 5px 5px;
    background: #242424;
    border: 1px solid #6490e8;
    border-top: none;
    list-style: none;
    animation: expandDown 0.15s ease-out;

    .selectItem {
      padding: 1vh 2vh;
      font-weight: 500;
      font-size: 3vh;
      line-height: 4vh;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #ffffff;
    }
    .selectItem:hover {
      background: #6f9af0;
    }
    .selectItem.selected {
      color: #6490e8;
    }
  }

  /* @media (max-width: 900px) {
    .selector {
      padding: 8px 5px 8px 10px;
      font-size: 12px;
    }
    .selectList {
      .selectItem {
        padding: 6px 8px;
        font-size: 12px;
      }
    }
  } */
`;
